import React from 'react';
import { components } from 'react-select';
import { Icon } from 'Permafrost/index';
import { addCustomProps } from 'Permafrost/components/ui-foundations/dropdowns/utils';
import { StyledMultiCombobox } from './MultiCombobox.styles';
/**
 * Multiselect combobox component. If selections are not bound to outside state
 * via the `value` prop, you will need to import and use the `useCombobox` hook
 * in order to clear its selected value .
 *
 * @see [useCombobox]{@link import('useCombobox').useCombobox}
 */
export const MultiCombobox = React.forwardRef((props, ref) => {
    const { className, closeMenuOnSelect, customOption, customOptionLabel, customOptionValue, defaultValue, disabled, id, loading, menuIsOpen, multiValueProps = {}, noOptionsMessage, onChange, optionProps = {}, options, placeholder, validationErrors, values, } = props;
    const MultiValue = (props) => {
        return React.createElement(components.MultiValue, Object.assign({}, props));
    };
    const MultiValueRemove = (props) => {
        return (React.createElement(components.MultiValueRemove, Object.assign({}, props),
            React.createElement(Icon, { name: "x-close", ariaLabel: "remove", size: [10] })));
    };
    // handles a custom option component generator, if passed in
    const Option = (props) => {
        if (customOption) {
            return (React.createElement(components.Option, Object.assign({}, props, optionProps), customOption(props)));
        }
        return React.createElement(components.Option, Object.assign({}, props, optionProps));
    };
    const ComboboxComponent = () => (React.createElement(StyledMultiCombobox, { "aria-label": props['aria-label'], "aria-labelledby": props['aria-labelledby'], ref: ref, className: className, classNamePrefix: "combobox", closeMenuOnSelect: closeMenuOnSelect, components: {
            MultiValue: addCustomProps(MultiValue, multiValueProps),
            MultiValueRemove,
            Option: addCustomProps(Option, optionProps),
        }, defaultValue: defaultValue, getOptionLabel: customOptionLabel, getOptionValue: customOptionValue, id: id, isClearable: false, isDisabled: disabled, isMulti: true, isLoading: loading, menuIsOpen: menuIsOpen, noOptionsMessage: () => noOptionsMessage, onChange: onChange, options: options, placeholder: placeholder, validationErrors: validationErrors, value: values }));
    if (props['data-cy']) {
        return (React.createElement("div", { "data-cy": props['data-cy'] },
            React.createElement(ComboboxComponent, null)));
    }
    return React.createElement(ComboboxComponent, null);
});
//# sourceMappingURL=MultiCombobox.js.map